/**
 * Wherever this is imported, please ensure to have the Snackbar component as well.
 * As we are sending saved message from here.
 */

import axios from 'axios'
import {useConnectionsStore} from '@/stores/ConnectionsStore'
import {findIndex, isArray} from 'lodash'
import Vue from 'vue'
import MixinGenericHelper from '@/mixins/generic/MixinGenericHelper'
import {eventBus} from '@/main'

// axios.defaults.baseURL = 'http://confixapi.dev.com';
// axios.defaults.baseURL = 'http://localhost:3111/api/'

if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'
    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'
    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}
export default {
    mixins: [MixinGenericHelper],
    methods: {

        configConnectionDelete(externalConnectionToDelete = false) {

            let self = this

            self.closeConnectionDropDown()

            /*let reset = function () {
                self.currentConnection = {};
                self.connectionHistory = [];
            }*/

            let deleteConnection = () => {

                const connectionsStore = useConnectionsStore()
                if (!externalConnectionToDelete) {
                    connectionsStore.deleteCurrentConnectionAndDeleteItFromConnectionHistory()
                } else {
                    connectionsStore.deleteCurrentConnectionAndDeleteItFromConnectionHistory(externalConnectionToDelete)
                }

                self.genericLocalStorageSetItem('connections', self.connections)

                if (!externalConnectionToDelete) {

                    // Temporarily we are defaulting to local
                    if (1 === 0) {

                        let previousConnection = connectionsStore.getLastElementFromConnectionHistoryIfItExists()

                        if (previousConnection) {

                            Vue.set(self, 'currentConnection', previousConnection)

                            eventBus.$emit('currentConnectionChanged', {
                                value: previousConnection,
                                operation: 'delete',
                            })

                        } else {
                            eventBus.$emit('fallbackCurrentConnectionToLocalEvent')
                        }

                    } else {
                        eventBus.$emit('fallbackCurrentConnectionToLocalEvent')
                    }
                }

                self.$refs.snackbar.showSnackbar(self.$gettext('Connection deleted successfully'))

            }

            let swalOptions = {
                successCallback: deleteConnection,
                title: self.$gettext('Delete Connection'),
                description: self.$gettext('Are you sure you want to delete this connection?'),
                confirmButtonText: self.$gettext('Yes, delete it!'),
                icon: 'warning',
                successText: self.$gettext('Connection deleted successfully')
            }

            self.swalConfirmation(swalOptions)

        },

        configConnectionEditAConnectionAndUpdateConnectionHistory(connectionToUpdate, oldEditConnectionNameField) {

            const connectionsStore = useConnectionsStore()
            let connectionsFromStore = connectionsStore.getConnections()

            let index = findIndex(connectionsFromStore, {key: oldEditConnectionNameField})

            if (index !== -1) {

                connectionsStore.updateConnectionHistory(connectionsFromStore[index], connectionToUpdate)

                connectionsFromStore[index].key = connectionToUpdate.key
                connectionsFromStore[index].value = connectionToUpdate.value

                connectionsStore.setConnections(connectionsFromStore)
            } else {
                // TODO: log error here
            }

        }

    }

}
